<template>
    <div class="productAddWrap11_editProduct">
        <div class="desBox" style="text-align: center;">
            商品编辑
        </div>
        <div class="formBox">
            <el-form :model="ruleForm" :inline-message="true" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
                <el-form-item label="所属公司" prop="company">
                    <el-input v-model="ruleForm.companyName"  disabled></el-input>
                </el-form-item>
                <el-form-item label="所属品牌" prop="brand">
                    <el-input v-model="ruleForm.brand"  disabled></el-input>
                </el-form-item>
                <el-form-item label="商品ID" prop="itemUniqueNumber">
                    <el-input v-model="ruleForm.itemUniqueNumber"  disabled></el-input>
                </el-form-item>
                <el-form-item label="商品名称" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="款号" prop="kuanhao">
                    <el-input v-model="ruleForm.kuanhao" placeholder="请输入款号"></el-input>
                    <span class="memo">注：一个颜色作为一个款，多个颜色视为多款</span>
                </el-form-item>
                <el-form-item label="颜色" prop="color">
                    <el-input v-model="ruleForm.color" placeholder="请输入商品颜色" />
                    </el-input>
                </el-form-item>
                <el-form-item label="尺码" prop="size">
                    <el-input v-model="ruleForm.size" placeholder="请输入商品尺码"></el-input>
                    <span class="memo">注：各尺码用空格隔开，如：S M L</span>
                </el-form-item>
                <el-form-item label="类目" prop="type">
                    <el-input v-model="ruleForm.type" placeholder="请输入商品所属类目"></el-input>
                </el-form-item>
                <el-form-item label="吊牌价" prop="dpprice">
                    <el-input v-model="ruleForm.dpprice" placeholder="请输入商品吊牌价"></el-input>
                    <span class="memo">元</span>
                </el-form-item>
                <el-form-item label="订货价" prop="dhprice">
                    <el-input v-model="ruleForm.dhprice" placeholder="请输入商品订货价"></el-input>
                    <span class="memo">元</span>
                </el-form-item>
                <el-form-item label="是否为主推款" prop="isMain">
                    <el-radio-group v-model="ruleForm.isMain">
                        <el-radio :label="'y'">是</el-radio>
                        <el-radio :label="'n'">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上传商品图片" required>
                    <div class="imgBox" v-for="(list,index) in fileLists">
                        <p class="imgDeleteIcon" @click="deleteImgFromArr(index,fileLists)">
                            <i class="el-icon-delete"></i>
                        </p>
                        <img :src="IMG_PREV+list" alt="" >
                    </div>
                    <div class="uploadWrap">
                        <el-upload :name="'files'" :data="uploadData" 
                        :action="ajaxBasicUrl+'/file/UploadFileBatch'" :show-file-list="false" :on-success="uploadSuccessHandle"  
                        accept="image/png, image/jpeg, image/jpg">  
                            <div class="uploadInner" slot="trigger"  >
                                <i class="el-icon-plus"></i>
                            </div>
                            
                        </el-upload>
                    </div>
                    <span class="memo">注：首张图片视为主图，建议图片.png或.jpg格式，大小不超过10M</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
                </el-form-item>
            </el-form>
            <!-- <div>
                {{fileLists}}
            </div> -->
        </div>
    </div>
</template>

<script>
    import {json,wordData,utils} from '@/common/common.js'
    import axios from 'axios'
    import {api,ajaxPost} from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            var priceValidate = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请输入价格'));
                } else if (isNaN(value)) {
                    callback(new Error('必须为数字!'));
                } else if (value <= 0) {
                    callback(new Error('必须大于0!'));
                } else {
                    callback()
                }
            };
            return {
                uploadData:{},
                companyLists:[],
                brandLists:[],
                itemUniqueNumber:'',
                conferenceId:'',
                dialogImageUrl: '',
                dialogVisible: false,
                fileLists:[],
                ruleForm: {
                    company:'',
                    brand:'',
                    name:'',
                    kuanhao:'',
                    color:'',
                    size:'',
                    type:'',
                    isMain:'',
                    dpprice:'',
                    dhprice:'',
                    itemUniqueNumber:'',
                },
                rules: {
                    company: [{
                        required: true,
                        message: '公司未选择',
                        trigger: 'change'
                    }],
                    brand: [{
                        required: true,
                        message: '品牌未选择',
                        trigger: 'change'
                    }],
                    name: [{
                        required: true,
                        message: '商品名称必填',
                        trigger: 'blur'
                    }],
                    kuanhao: [{
                        required: true,
                        message: '款号必填',
                        trigger: 'blur'
                    }],
                    color: [{
                        required: true,
                        message: '颜色必填',
                        trigger: 'blur'
                    }, ],
                    size: [{
                        required: true,
                        message: '尺码必填',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '类目必填',
                        trigger: 'blur'
                    }],
                    dpprice: [{
                        validator: priceValidate,
                        trigger: 'blur'
                    }],
                    dhprice: [{
                        validator: priceValidate,
                        trigger: 'blur'
                    }],
                    isMain: [{
                        required: true,
                        message: '是否为主推款',
                        trigger: 'blur'
                    }, ],
                },
            }
        },
        computed: {
            IMG_PREV() {
                return api.imgPrev
            },
            ajaxBasicUrl(){
                return api.baseUrl
            }
            
        },
        methods: {
            deleteImgFromArr(index,fileLists){
                fileLists.splice(index,1)
            },
            uploadSuccessHandle(res, file, fileList){
                console.log("图片上传成功回调")
                console.log(res,file,fileList)
                let buffer=res
                this.fileLists.push(buffer)
            },
            getDetail(){
                let _this=this
                let arg={
                  conferenceId:this.conferenceId ,
                  itemUniqueNumber:this.itemUniqueNumber
                }
                ajaxPost('/admin/showMallItem', arg).then(function(res) {
                    _this.ruleForm={
                        companyName:res.data.companyName,
                        company:res.data.userId,
                        brand:res.data.brandName,
                        name:res.data.itemName,
                        kuanhao:res.data.styleNumber,
                        color:res.data.colorName,
                        size:res.data.sizeNames?res.data.sizeNames.split(",").join(" "):'',
                        type:res.data.categoryName,
                        isMain:res.data.itemIsRecommend,
                        dpprice:res.data.itemOriginalPrice,
                        dhprice:res.data.itemOrderPrice,
                        itemUniqueNumber:res.data.itemUniqueNumber,
                    }
                    _this.fileLists=res.data.images?res.data.images.split(","):[]
                   
                }, function(res) {
                
                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                this.itemUniqueNumber = this.$route.params.itemUniqueNumber
            },
            changeUploadSuccess(file,fileList){
              console.log("fileList---- changeUploadSuccess----")  
              console.log(fileList)  
              this.fileLists=fileList
            },
            submitForm(formName) {
                let _this = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {//ces
                        //1.图片
                        if(_this.fileLists.length==0){
                            alert("至少上传一张图片")
                            return false
                        }
                        // 2.尺码
                        _this.ruleForm.size.replace(/\s+/g, ' ');
                        // 3.组装所有
                        let arg={
                            itemUniqueNumber:_this.ruleForm.itemUniqueNumber,
                            userId:_this.ruleForm.company,
                            brandName:_this.ruleForm.brand,
                            styleNumber:_this.ruleForm.kuanhao,
                            colorName:_this.ruleForm.color,
                            sizeName:_this.ruleForm.size,
                            itemName:_this.ruleForm.name,
                            itemOrderPrice:_this.ruleForm.dhprice,
                            itemOriginalPrice:_this.ruleForm.dpprice,
                            categoryName:_this.ruleForm.type,
                            itemIsRecommend:_this.ruleForm.isMain,
                            conferenceId:_this.conferenceId,
                            images:_this.fileLists.join(",")
                        }
                        console.log(arg)
                        ajaxPost('/admin/updateMallItem', arg).then(function(res) {
                            if(res.errorCode==200){
                               _this.$message({
                                  message: "修改成功", //接口返回一个页面
                                  type: 'success',
                                  duration: 2000
                              });
                              setTimeout(function(){
                                  _this.$router.back()
                              },500)
                            }
                        }, function(res) {
                        
                        })
                        
                    } else {
                        _this.$message({
                            message: "表单填写不完整或格式不正确", //接口返回一个页面
                            type: 'warning',
                            duration: 1000
                        });
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
        mounted(){
            this.getParams()
            this.getDetail()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .productAddWrap11_editProduct {
        .uploadInner{width: 140px;height: 140px; border:1px dotted #999;line-height: 140px;}
        .imgBox{display: inline-block;width: 140px; height: 140px;border:1px solid #aaa; vertical-align: top;margin-right:10px; margin-bottom:10px; padding:2px; position: relative;
            img{max-width: 100%;max-height: 100%;}
            .imgDeleteIcon{position: absolute; height: 20px; line-height: 20px;width: 20px; text-align: center; border:1px solid #ddd;top:-5px;right:-5px;background: #aaa;cursor: pointer;border-radius: 6px;}
            .imgDeleteIcon:hover{cursor: pointer;background: blue;color:#fff;}
        }
        .uploadWrap{display: inline-block;}
        .inlineInputBox {
            display: inline-block;
        }

        .el-input {
            width: 217px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }

        background: #fff;
        padding:0 30px 20px 30px;

        .desBox {
            padding: 10px 0;
            background: #ddd;
            width: 900px;
            padding-right: 22px;

            .textBox {
                border-left: 4px solid skyblue;
                padding-left: 20px;
                font-size: 12px;

                .titleText {
                    font-weight: bold;
                    margin-right: 30px;
                }

                .first {
                    margin-right: 30px;
                }
            }

            // padding:10px 30px; background: #eee;font-size: 12px;  
            // .titleBox{border-left:2px solid skyblue;padding-left:20px;margin-bottom: 10px;font-weight: bold;height: 11px;line-height: 11px;}
        }

        .formBox {
            padding-top: 10px;
            background: #fff;
            padding: 10px;
            border: 1px solid #ccc;
            border-top: 0;
            width: 900px;

            .memo {
                color: #999;
                font-size: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/productEdit.vue